import { render, staticRenderFns } from "./payPopup.vue?vue&type=template&id=230dece9"
import script from "./payPopup.vue?vue&type=script&lang=ts"
export * from "./payPopup.vue?vue&type=script&lang=ts"
import style0 from "./payPopup.vue?vue&type=style&index=0&id=230dece9&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports